import React from "react";
import "./footer.css";
import logoB from "../../assets/images/logo.png";
import YouTube from "../../assets/icons/YouTube.svg";
import Twiter from "../../assets/icons/Twiter.svg";
import LinkedIn from "../../assets/icons/LinkedIn.svg";
import Instagram from "../../assets/icons/Instagram.svg";
import useLanguage from "../../hooks/useLanguage";
import { useSelector } from "react-redux";
import { selectUserLanguage } from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";

const Footer = ({ inLandingPage = true }) => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    if (!inLandingPage) {
      handleNavigation("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        section?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      const section = document.getElementById(id);
      section?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const currentLanguage = useSelector(selectUserLanguage) || "es";

  const texts = useLanguage(currentLanguage, "views.landingPage");

  return (
    <>
      <div className="amvi-footer">
        <div className="top-footer">
          <div className="brand-container">
            <img
              src={logoB}
              alt="logoB"
              onClick={() => scrollToSection("main")}
            />
            <label>{texts.footer.slogan}</label>
          </div>
          <div className="names-section">
            <label onClick={() => scrollToSection("beneficios")}>
              {texts.footer.beneficios}
            </label>
            <label onClick={() => scrollToSection("incentivos")}>
              {texts.footer.incentivos}
            </label>
            <label onClick={() => scrollToSection("planes")}>
              {texts.footer.planes}
            </label>
            <label onClick={() => scrollToSection("aplicaion")}>
              {texts.footer.aplicacion}
            </label>
          </div>
        </div>
        <div className="bottom-footer">
          <div className="social-links-container">
            <a
              href="https://www.youtube.com/@amvicarpooling"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={YouTube} alt="YouTube" />
            </a>
            <a
              href="https://x.com/amvicarpooling"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Twiter} alt="Twiter" />
            </a>
            <a
              href="https://www.linkedin.com/company/amvi-mobility/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={LinkedIn} alt="LinkeIn" />
            </a>
            <a
              href="https://www.instagram.com/amvicarpooling/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Instagram} alt="Instagram" />
            </a>
          </div>
          <div className="footer-links">
            <label>{texts.footer.terms}</label>
            <label>{texts.footer.privacy}</label>
            <label>{texts.footer.faq}</label>
          </div>
        </div>
      </div>
      <div className="all-rights-reserved">
        <div></div>
        <label>{texts.footer.rights}</label>
        <label className="version-label">v0.9.6</label>
      </div>
    </>
  );
};

export default Footer;
